import { has, have } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" })) {
                if ([undefined, "draft", "reEdit"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forCustoms" })) {
                if (["waitReceiveCustoms", "waitDocCustoms"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forCenter" })) {
                if (["waitApproveCenter"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" })) {
                if (["draft"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forOfficeRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (have({ menuContext, keys: ["forCustoms", "forCenter"] })) {
                    if (["waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refRequestType",
                    "refUserTemp.refTitle",
                    "refUserTemp.firstNameTh",
                    "refUserTemp.middleNameTh",
                    "refUserTemp.lastNameTh",
                    "refUserTemp.fullNameTh",
                    "refUserTemp.firstNameEn",
                    "refUserTemp.middleNameEn",
                    "refUserTemp.lastNameEn",
                    "refUserTemp.fullNameEn",
                    "refUserTemp.mobile",
                    "refUserTemp.addresses.0.noTh",
                    "refUserTemp.addresses.0.noEn",
                    "refUserTemp.addresses.0.roomTh",
                    "refUserTemp.addresses.0.roomEn",
                    "refUserTemp.addresses.0.buildingTh",
                    "refUserTemp.addresses.0.buildingEn",
                    "refUserTemp.addresses.0.floorTh",
                    "refUserTemp.addresses.0.floorEn",
                    "refUserTemp.addresses.0.villageTh",
                    "refUserTemp.addresses.0.villageEn",
                    "refUserTemp.addresses.0.mooTh",
                    "refUserTemp.addresses.0.mooEn",
                    "refUserTemp.addresses.0.soiTh",
                    "refUserTemp.addresses.0.soiEn",
                    "refUserTemp.addresses.0.roadTh",
                    "refUserTemp.addresses.0.roadEn",
                    "refUserTemp.addresses.0.refProvince",
                    "refUserTemp.addresses.0.refAmphur",
                    "refUserTemp.addresses.0.refTambon",
                    "refUserTemp.addresses.0.postCode"
                ].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refUser"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserTemp.password",
                    "refUserTemp.passwordConfirm",
                    "refUserTemp.refDocumentTypePerson",
                    "refUserTemp.refIssuedBy",
                    "refUserTemp.outDate",
                    "refUserTemp.expireDate",
                    "refUserTemp.birthDate",
                    "refUserTemp.refNationality",
                    "refUserTemp.refRace",
                    "refUserTemp.refReligion",
                    "refUserTemp.refGender"
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        if (modelRef.refRequestType?.key === "1") {
                            enabled = !viewOnly || enabled;
                        }
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.idCard"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                let suffix = undefined;
                if (has({ menuContext, key: "forRequest" })) {
                    suffix = null;
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        if (modelRef.refRequestType?.key === "1") {
                            enabled = !viewOnly || enabled;
                        }
                    }
                }
                if (has({ menuContext, key: "forCustoms" })) {
                    suffix = null;
                }
                return { disabled: !enabled, suffix };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.username"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                let onUpdateValue = value => {
                    modelRef.refUserTemp.username = value;
                    modelRef.refUserTemp.email = value;
                };
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        if (!modelRef.id && modelRef.refRequestType?.key === "1") {
                            enabled = !viewOnly || enabled;
                        }
                    }
                }
                return { disabled: !enabled, "onUpdate:value": onUpdateValue };
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.addresses.0.refAddressType"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refUserTemp.addresses.0.tel",
                    "refUserTemp.addresses.0.fax",
                    "refUserTemp.addresses.0.latitude",
                    "refUserTemp.addresses.0.longitude",
                    "refUserTemp.addresses.0.map"
                ].includes(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.buttonCheckIdCard"].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (has({ menuContext, key: "forCenter" })) {
                    if (["waitApproveCenter"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                return result;
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                let canCreate = false;
                let canDelete = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                        canCreate = !viewOnly || canCreate;
                        canDelete = !viewOnly || canDelete;
                    }
                }
                return { viewOnly: !enabled, canCreate, canDelete };
            }
        }
    ];
};
